export class ResourceSpecificData {
    languages: any[];
    minPax: number;
    maxPax: number;
    grade: string;
    yearsOfExperience: number;

}
